import React, { useState } from 'react'
import { GENRE_NAMES, getSubgenres, getGenreIcon } from '../utils/genres.js'

export default function GenrePicker({ genre, subgenre, onGenreChange, onSubgenreChange }) {
  const [step, setStep] = useState(genre ? 'subgenre' : 'genre')

  function selectGenre(g) {
    onGenreChange(g)
    onSubgenreChange('')
    setStep('subgenre')
  }

  function changeGenre() {
    setStep('genre')
  }

  if (!genre || step === 'genre') {
    return (
      <div className="genre-picker">
        <div className="genre-picker__grid">
          {GENRE_NAMES.map(g => (
            <button
              key={g}
              className={`genre-picker__tile${genre === g ? ' active' : ''}`}
              onClick={() => selectGenre(g)}
            >
              <span className="genre-picker__icon">{getGenreIcon(g)}</span>
              <span className="genre-picker__name">{g}</span>
            </button>
          ))}
        </div>
      </div>
    )
  }

  const subgenres = getSubgenres(genre)

  return (
    <div className="genre-picker">
      <div className="genre-picker__selected">
        <span className="genre-picker__selected-label">{getGenreIcon(genre)} {genre}</span>
        <button className="genre-picker__back-btn" onClick={changeGenre}>← Change genre</button>
      </div>
      {subgenres.length > 0 && (
        <div className="genre-picker__subgenres">
          {subgenres.map(s => (
            <button
              key={s}
              className={`genre-picker__sub${subgenre === s ? ' active' : ''}`}
              onClick={() => onSubgenreChange(subgenre === s ? '' : s)}
            >
              {s}
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
